export default "__VITE_ASSET__ae659ebe__"